import {Component, NgZone} from "@angular/core";

@Component({
  selector: "core-ngzone",
  template: `
  <usecase-container title="NgZone" src="core/ngzone">
    <usecase-content>
      <p>{{text}}</p>
      <p>Zone is {{stable?"Stable":"Unstable"}}</p>
      <button (click)="run()">Run zone</button>
    </usecase-content>
  </usecase-container>
    `,
})
export class NgZoneComponent {
  private text = "";
  private stable = false;

  constructor(private zone: NgZone) {
  }

  ngOnInit() {
    this.zone.onStable.subscribe(() => {
      this.stable = true;
    });
  }

  run() {
    this.stable = false;
    this.text = "running...";
    this.zone.run(() => {
      setTimeout(() => {
        this.text = "";
      }, 1000)
    });
  }
}



/** WEBPACK FOOTER **
 ** ./script/core/ngzone/component.ts
 **/